const finite = (value, fallback = 0) => {
  const n = Number(value)
  return Number.isFinite(n) ? n : fallback
}

const finitePositive = (value, fallback = 1) => {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? n : fallback
}

export const scaleAxisFromCode = (code) => {
  if (code === 'scale.x') return 'x'
  if (code === 'scale.y') return 'y'
  if (code === 'scale.z') return 'z'
  return null
}

export const buildFitScaleBaseline = ({ x = 1, y = 1, z = 1 } = {}) => ({
  x: finitePositive(x, 1),
  y: finitePositive(y, 1),
  z: finitePositive(z, 1),
})

export const readStripFitScaleBaseline = (strip, fallbackRaw = {}) => {
  const baseline = strip?.transformFitBaseline
  return buildFitScaleBaseline({
    x:
      typeof baseline?.x !== 'undefined'
        ? baseline.x
        : fallbackRaw?.x,
    y:
      typeof baseline?.y !== 'undefined'
        ? baseline.y
        : fallbackRaw?.y,
    z:
      typeof baseline?.z !== 'undefined'
        ? baseline.z
        : fallbackRaw?.z,
  })
}

export const rawScaleToFitPercent = (rawScale, baselineScale = 1) => {
  const baseline = finitePositive(baselineScale, 1)
  const raw = finite(rawScale, baseline)
  return (raw / baseline) * 100
}

export const fitPercentToRawScale = (percent, baselineScale = 1) => {
  const baseline = finitePositive(baselineScale, 1)
  const pct = finite(percent, 100)
  return (pct / 100) * baseline
}
